import { listKiosks } from './index';

import { kiosksRouteStore } from '../domain/store';

export default () => {
  if (!kiosksRouteStore.http.listingKiosk) return listKiosks();
};
